import { Currency } from 'types/Currency';

export const CURRENCY_ARRAY = [Currency.EUR, Currency.USD];

export const CURRENCY_OPTIONS = CURRENCY_ARRAY.map((value) => ({
  label: value,
  value,
}));
